/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, manage } = {}) {
    const params = new URLSearchParams();
    if (searchKey) params.append('search', searchKey);
    if (manage) params.append('manage', 'true');
    const queryString = params.toString();
    const url = queryString ? `${this.url}?${queryString}` : this.url;
    return axios.get(url);
  }
}

export default new CannedResponse();
